<template lang="pug">
    div
        Input(
            :value="valueToString"
            @on-change="updateParent"
            :placeholder="placeholder"
            :autosize="autosize"
            :type="fieldType"
            :disabled="disabled"
        )
</template>
<script>
export default {
    props: ["formItem", "formData", "value"],
    data() {
        return {
            placeholder: this.formItem.placeholder || "",
            autosize: this.formItem.autosize || false,
            fieldType: this.formItem.fieldType || "text",
        };
    },
    methods: {
        updateParent(event) {
            const value = !event.target.value ? [] : event.target.value.split("\n");
            this.$emit("input", value);
            if (typeof this.formItem.watchField === "function") {
                this.formItem.watchField(value, this.formData);
            }
        },
    },
    computed: {
        valueToString() {
            return Array.isArray(this.value) ? this.value.join("\n") : this.value;
        },
        disabled() {
            return typeof this.formItem.disabled == "function" ? this.formItem.disabled() : this.formItem.disabled;
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/WafFingerprintInput.vue